import { Grid } from '@lightningjs/ui';
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Colors, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';

export default class Avatars extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Wrapper: {
        x: 0,
        y: 0,
        w: 1920,
        flex: {
          direction: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        TitleWrapper: {
          zIndex: 10,
          y: 0,
          h: 150,
          w: 1920,
          rect: true,
          color: Colors('#000000').alpha(0.9).get(),
          Title: {
            y: 50,
            w: 1920,
            text: {
              textAlign: 'center',
              text: 'Choose your avatar icon',
              fontSize: 53,
            },
          },
        },
        Column: {
          type: Column,
          collision: true,
          plinko: true,
          x: (1920 - 1370) / 2,
          y: 50,
          scrollIndex: 1,
          w: 1920,
          h: 930,
        },
      },
    };
  }

  set pageItems(val) {
    this._pageItems = val;
  }
  get id() {
    return 'AvatarPage';
  }

  get _Column() {
    return this.tag('Column');
  }

  $unselectCurrentIndex() {
    let currentIndex = this._Column.selectedIndex;
    let rowIndex = (this._Column.items[currentIndex].selectedIndex = undefined);
  }

  $setIndex({ rowIndex, index }) {
    let modifiedIndex = index % 5;
    this._Column.scrollTo(rowIndex, 400);
    this._Column.items[rowIndex].selectedIndex = modifiedIndex;
  }
  _getFocused() {
    return this._Column;
  }
}
